/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { SupplierUserContext } from '@gh/supplier-shared';
import { SupplierInvoicesRestService } from '@gh/supplier-shared-data';
import { Observable } from 'rxjs';
import { InvoicesModel } from '../models';

@Injectable()
export class SupplierInvoicesListBusinessService {
  constructor(
    private userContext: SupplierUserContext,
    private restService: SupplierInvoicesRestService,
  ) {
  }

  getAll(): SlicedDataSource<InvoicesModel> {
    return this.restService.getAll();
  }

  delete(id: ID): Observable<InvoicesModel> {
    return this.restService.delete(id);
  }
}
